import { CatalogPage } from '~/components/CatalogPage/CatalogPage'
import { PromoLeadPopup } from '~/components/PromoLeadPopup/PromoLeadPopup'

export default function CatalogRoutePage() {
  return (
    <>
      <CatalogPage />
      <PromoLeadPopup scrollEngagement />
    </>
  )
}
